import searchIcon from "../../../../assets/icons/search-icon-white.svg";
import React, {useCallback, useState} from "react";
import './index.scss';
import {debounce} from "../../../../app/functions";

const SearchInput = ({ setQuery, translations }) => {

    const [text, setText] = useState('')

    const updateValue = useCallback(debounce((val)=>setQuery(val), 300), [])

    const handleKeydown = (event) => {
        switch (event.key) {
            case 'Enter':
            case 'Tab':
                setQuery(text); // Update the search query
                event.preventDefault();
                break;
            default:
                break;
        }
    };

    const handleButtonClick = () => {
        setQuery(text);
    };

    const handleChange = (e) => {
        setText(e.target.value);
       updateValue(e.target.value)
    };

    return (
        <>
            <h3 style={{ color: '#000000d9', marginBottom: 10 }}>{translations['_free_text_filter']}</h3>
            <div className='search-form'>
                <input
                    type="text"
                    className="search-input"
                    placeholder={translations['free_text_placeholder']}
                    value={text}
                    onKeyDown={handleKeydown}
                    onChange={handleChange}
                    style={{borderColor: '#8533eb'}}
                />

                <button
                    type="submit"
                    className="search-button"
                    onClick={handleButtonClick}
                >
                    <img
                        src={searchIcon}
                        alt="Search Icon"
                        className="search-button-icon"
                    />
                </button>
            </div>
        </>
    );
};

export default SearchInput;
